module.exports = __webpack_public_path__ + "assets/life_email_v1.51721fde.svg";